import MuiPaper, { PaperProps } from "@mui/material/Paper";

const Paper: React.FC<PaperProps> = MuiPaper;

export default Paper;
export type { PaperProps };
